import styled from 'styled-components';

export const MRIContainer = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    box-sizing: border-box;
    cursor: text;
    display: flex;
    flex-direction: column;
    min-height: 56px;
    padding: 24px 10px 8px 10px;
    position: relative;
    transition: border-color 0.2s ease;
    width: 100%;

    &:focus-within {
        border-color: rgba(255, 255, 255, 0.45);
    }
`;

export const MRILabel = styled.label`
    color: rgba(255, 255, 255, 0.5);
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    left: 0.75rem;
    pointer-events: none;
    position: absolute;
    top: 0.5rem;
`;

export const MRIBody = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    min-height: 24px;
`;

export const MRITag = styled.span`
    align-items: center;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 5px;
    color: rgba(255, 255, 255, 0.9);
    display: flex;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
    gap: 4px;
    padding: 2px 4px 2px 8px;
    white-space: nowrap;
`;

export const MRITagRemove = styled.button`
    align-items: center;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    display: flex;
    font-size: 14px;
    justify-content: center;
    line-height: 1;
    padding: 0 2px;
    transition: color 0.15s ease;

    &:hover { color: rgba(255, 100, 100, 0.9); }
`;

export const MRIInput = styled.input`
    background: none;
    border: none;
    color: #fff;
    flex: 1;
    font-family: 'Inter', 'Roboto Condensed', sans-serif;
    font-size: 14px;
    font-weight: 500;
    min-width: 80px;
    outline: none;
    padding: 0;

    &::placeholder { color: rgba(255, 255, 255, 0.3); }
`;
